module.exports = __webpack_public_path__ + "img/united-kingdom-flag.624b932a.svg";